import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isAuth } from '../../../lib/Helper';
import AuthRedirect from '../../../components/redirect/AuthRedirect';
import { Breadcrumb, Tabs, Row, Col } from 'antd';
import { PageHeader } from 'components/header';
import { DoubleRightOutlined } from '@ant-design/icons';
import TataTertib from './TataTertib';
import DataPelanggaran from './pelanggaran/DataPelanggaran';
import Penghargaan from './Penghargaan';

const TataTertibSekolah = ({ privilege, history, location }) => {
  const [tabIdx, setTabIdx] = useState('0');

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    setTabIdx(query.get('tab') || '0');
  }, [location.search]);

  const onChangeTab = (key) => {
    history.push({
      pathname: window.location.pathname,
      search: "?" + new URLSearchParams({ tab: key }).toString(),
    });

    setTabIdx(key);
  };

  const access = privilege.access["/kesiswaan/tata-tertib-sekolah"];
  if (!isAuth(privilege) || access === undefined) {
    return <AuthRedirect />;
  }

  const steps = [
    {
      key: '0',
      label: 'Tata Tertib',
      children: <TataTertib />,
    },
    {
      key: '1',
      label: 'Pelanggaran',
      children: <DataPelanggaran {...privilege} />,
    },
    {
      key: '2',
      label: 'Penghargaan',
      children: <Penghargaan />,
    },
  ];

  return (
    <>
      <PageHeader
        style={{ padding: 0 }}
        onBack={() => window.history.back()}
        title={
          <Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />} items={[
            { title: 'Kesiswaan' },
            { title: 'Tata Tertib Sekolah' },
          ]} />
        }
      />

      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <Tabs defaultActiveKey="0" activeKey={tabIdx} onChange={onChangeTab} items={steps} />
          </Col>
        </Row>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  privilege: state.privilege,
});

export default connect(mapStateToProps)(TataTertibSekolah);
